import { useState } from "react";
import { modulesAtom } from "atoms/GlobalAtoms";
import ModulePicker from "components/Modules/ModulePicker";
import { CheckPicker, SelectPicker } from "rsuite/esm";
import ImportDataWidget from "components/Widgets/ImportDataWidget/ImportDataWidget";
import { useAtomValue } from "jotai";
import _ from "underscore";

const RecordCreateSubitems = ({ action, setAction, actions }) => {
  const modules = useAtomValue(modulesAtom);

  const handleChange = (newPayload) => {
    setAction((prev) => ({
      ...prev,
      ...newPayload,
    }));
  };

  const handleNewModule = (newMod) => {
    if (!newMod) return;

    const module = _.findWhere(modules, { APIName: newMod });

    if (!module) return;

    const payload = {
      ModuleAPIName: newMod,
      Name: `Create Records Subitems`,
      Description: `In the ${module?.Name} data source, records will be imported using the provided file/data.`,
    };

    setAction((prev) => ({ ...prev, ...payload }));
  };

  const handleMultiSubitemFieldChange = (field) => {
    const newMultiSubitemField = field;
    if (!newMultiSubitemField) return;

    const payload = {
      Field: newMultiSubitemField,
      ModuleAPIName: action.ModuleAPIName,
    };

    setAction((prev) => ({ ...prev, ImportInto: { ...payload } }));
  };

  return (
    <>
      <h3>Data Source</h3>
      <ModulePicker
        value={action?.ModuleAPIName}
        onChange={(newMod) => handleNewModule(newMod)}
        size="md"
        defaultOpen={!action?.ModuleAPIName}
      />
      <hr></hr>
      {action?.ModuleAPIName && (
        <>
          <h5 className="mt-4">Select MultiSubitem Field</h5>
          <SelectPicker
            data={availableFields() || []}
            labelKey="Name"
            valueKey="APIName"
            placeholder={`Select ${action?.ModuleAPIName} MultiSubitem Field`}
            onChange={(field) => handleMultiSubitemFieldChange(field)}
            value={action?.ImportInto?.Field}
            cleanable={false}
            block
            preventOverflow
          />
        </>
      )}
      {action?.ImportInto?.Field && (
        <div className="mt-4">
          {action?.ModuleAPIName && (
            <>
              <ImportDataWidget
                moduleAPIName={action?.ModuleAPIName}
                onChange={handleChange}
                actions={actions}
                existingData={action}
              />
            </>
          )}
        </div>
      )}
    </>
  );

  function availableFields() {
    let availableMultiSubitemFields = [];
    if (!action || !action?.ModuleAPIName) return availableMultiSubitemFields;

    const module = _.findWhere(modules, { APIName: action?.ModuleAPIName });

    if (!module) return availableMultiSubitemFields;

    availableMultiSubitemFields = module.Fields.filter(
      (field) => field.FieldType === "MultiSubitem"
    );

    return availableMultiSubitemFields;
  }
};

export default RecordCreateSubitems;
